import React, { useState, useEffect, useRef } from "react";
import { Element } from "react-scroll";
import { href, Link } from "react-router-dom";
import {db} from "../firebase/firebase";
import {
  collection,
  addDoc,
  onSnapshot,
  query,
  where,
  getDocs,
  serverTimestamp,doc,
  setDoc,
  increment
} from "firebase/firestore";
import { motion, AnimatePresence } from "framer-motion";
import { 
  CalendarDays, 
  Sparkles, 
  BookHeart,
  ChevronLeft,
  Filter,
  Clock, 
  MapPin, 
  Phone, 
  Mail, 
  ArrowRight, 
  PlayCircle, 
  Sun, 
  Users, 
  CloudSun,
  X,
  ChevronRight,
  Menu
} from "lucide-react";

import Hero from "./Hero";
import InvitationSection from "./InvitationSection";
import CBookingUser from "./CulturalProgram";
import CulturalStatusTracker from "./CulturalStatusTracker";
import Footer from "./Footer";
import MantrakshataRequest from "./Mantrakshate";
import LiveDarshanSection from "./LiveDarshan";
import LiveBroadcast from "./LiveBroadcast"
import Schedule from "./Schedule"; 
import BlogSection from "./Blogs";
import Header from "./Header";
import Bio from "./Bio"
import { useLanguage } from "../context/LanguageContext";
import CommitteeSection from "./Committee";
import Gallery from "./Gallery";
import ReviewSection from "./ReviewSection";

// --- Framer Motion Variants ---
const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: [0.16, 1, 0.3, 1] } }
};

const staggerContainer = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.15 }
  }
};

const Home = () => {
  console.log("HOME");
  const { language } = useLanguage();
  const [selectedBlog, setSelectedBlog] = useState(null);
  const [activeFilter, setActiveFilter] = useState({ type: 'all', value: 'all' });
  const carouselRef = useRef(null);
  const scrollCarousel = (direction) => {
    if (carouselRef.current) {
      const scrollAmount = direction === 'left' ? -350 : 350;
      carouselRef.current.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    }
  };

  const t = homeText[language];

  const handleFilterChange = (type, value) => {
    if (value === "") setActiveFilter({ type: 'all', value: 'all' });
    else setActiveFilter({ type, value });
  };

  const dailySchedule = [
    { id: 1, timePre: "06:00", timePost: "AM", title: "Suprabhata Seva", status: "past" },
    { id: 2, timePre: "08:00", timePost: "AM", title: "Sri Rama Devara Pooja", status: "past" },
    { id: 3, timePre: "10:00", timePost: "AM", title: "Pravachana", status: "past" },
    { id: 4, timePre: "12:30", timePost: "PM", title: "Mahamangalarati & Teertha Prasada", status: "ongoing" },
    { id: 5, timePre: "05:00", timePost: "PM", title: "Veda Parayana", status: "future" },
    { id: 6, timePre: "07:00", timePost: "PM", title: "Bhajane & Sandhya Vandana", status: "future" },
  ];
  const [isMenuOpen, setIsMenuOpen] = useState(false);
 // --- Cultural Booking Form State ---
  const MAX_BOOKINGS_PER_DAY = 3;
  const [selectedDateId, setSelectedDateId] = useState("");
  const [approvedBookings, setApprovedBookings] = useState([]);
  const [culturalForm, setCulturalForm] = useState({
    name: "",
    contact: "",
    category: "",
    otherCategory: "",
    groupName: "",
    address: "",
    state: "",
    district: "",
    city: "",
    pincode: "",
  });
  const [bookingType, setBookingType] = useState("solo");
  const [groupCount, setGroupCount] = useState(2);
  const [isSubmittingCultural, setIsSubmittingCultural] = useState(false);
  const [visitorCount, setVisitorCount] = useState(0);
  // ------------------------------------------------------------
  // Generate every booking date from July 29 to September 26
  // ------------------------------------------------------------

  const generateCulturalDates = () => {
    const startDate = new Date(2026, 6, 29);
    const endDate = new Date(2026, 8, 26);

    const dates = [];  
    const currentDate = new Date(startDate);

    while (currentDate <= endDate) {
      const year = currentDate.getFullYear();
      const month = String(currentDate.getMonth() + 1).padStart(2, "0");
      const day = String(currentDate.getDate()).padStart(2, "0");

      const dateId = `${year}-${month}-${day}`;

      dates.push({
        id: dateId,

        dayNumber: currentDate.getDate(),

        monthShort: currentDate.toLocaleDateString("en-US", {
          month: "short",
        }),

        monthLong: currentDate.toLocaleDateString("en-US", {
          month: "long",
        }),

        weekday: currentDate.toLocaleDateString("en-US", {
          weekday: "short",
        }),

        fullDate: currentDate.toLocaleDateString("en-IN", {
          day: "numeric",
          month: "long",
          year: "numeric",
        }),
      });

      currentDate.setDate(currentDate.getDate() + 1);
    }

    return dates;
  };

  const culturalDates = generateCulturalDates();

  // ------------------------------------------------------------
  // Listen to approved bookings
  // ------------------------------------------------------------

  useEffect(() => {
    const culturalRequestsRef = collection(db, "culturalRequests");

    const unsubscribe = onSnapshot(
      culturalRequestsRef,

      (snapshot) => {
        const bookings = snapshot.docs.map((bookingDoc) => ({
          id: bookingDoc.id,
          ...bookingDoc.data(),
        }));

        setApprovedBookings(
          bookings.filter(
            (booking) =>
              booking.status?.toLowerCase() === "approved"
          )
        );
      },

      (error) => {
        console.error(
          "Unable to load Cultural Seva availability:",
          error
        );
      }
    );

    return () => unsubscribe();
  }, []);

  useEffect(() => {
  const visitorRef = doc(db, "websiteStats", "visitors");

  // Listen for live visitor count updates
  const unsubscribe = onSnapshot(visitorRef, (snapshot) => {
    if (snapshot.exists()) {
      setVisitorCount(snapshot.data().count || 0);
    }
  });

  // Count every page load as one visit
  const countVisit = async () => {
    try {
      await setDoc(
        visitorRef,
        {
          count: increment(1),
          lastVisitedAt: serverTimestamp(),
        },
        { merge: true }
      );
    } catch (error) {
      console.error("Unable to update visitor count:", error);
    }
  };

  countVisit();

  return () => unsubscribe();
}, []);

  // ------------------------------------------------------------
  // Availability helpers
  // ------------------------------------------------------------

  const getApprovedBookingCount = (dateId) => {
    return approvedBookings.filter(
      (booking) => booking.date === dateId
    ).length;
  };

  const parseLocalDate = (value) => {
  if (!value) return null;
  const [year, month, day] = value.split("-").map(Number);
  return new Date(year, month - 1, day);
};

const getMaxSlotsForDate = (dateId) => {
  const date = parseLocalDate(dateId);
  if (!date) return 3;

  // Monday = 1
  return date.getDay() === 1 ? 2 : 3;
};

  const getRemainingSlots = (dateId) => {
      const maxSlots = getMaxSlotsForDate(dateId);

      return Math.max(
        0,
        maxSlots - getApprovedBookingCount(dateId)
      );
  };

  const selectedDateData = culturalDates.find(
    (date) => date.id === selectedDateId
  );

  const selectedDateRemainingSlots = selectedDateId
    ? getRemainingSlots(selectedDateId)
    : null;

  // ------------------------------------------------------------
  // Submit booking request
  // ------------------------------------------------------------

  const handleCulturalSubmit = async (e) => {
    e.preventDefault();

    const name = culturalForm.name.trim();
    const contact = culturalForm.contact.trim();
    const category = culturalForm.category;

const finalCategory =
  category === "Others"
    ? culturalForm.otherCategory.trim()
    : category;

    if (!name) {
      alert("Please enter your full name.");
      return;
    }

    if (!/^[6-9]\d{9}$/.test(contact)) {
      alert("Please enter a valid 10-digit mobile number.");
      return;
    }

    if (!category) {
  alert("Please select a program category.");
  return;
}

if (category === "Others" && !finalCategory) {
  alert("Please enter the program category.");
  return;
}

    if (!selectedDateId) {
      alert("Please select an available date.");
      return;
    }

    if (getRemainingSlots(selectedDateId) <= 0) {
      alert(
        "All Cultural Seva booking slots for this date are already booked."
      );
      return;
    }

    if (
      bookingType === "group" &&
      (!groupCount || Number(groupCount) < 2)
    ) {
      alert("Please enter a valid number of group members.");
      return;
    }

  const uniqueId = `KMCP${Date.now()
    .toString()
    .slice(-7)}`;

  try {
    setIsSubmittingCultural(true);

    await addDoc(collection(db, "culturalRequests"), {
      bookingId: uniqueId,

      name,

      contact,

      date: selectedDateId,

      participationType: bookingType,

      participantCount:
        bookingType === "group"
          ? Number(groupCount)
          : 1,

      status: "pending",

      createdAt: serverTimestamp(),
    });

    alert(
      `Request Submitted Successfully!\n\nReference ID: ${uniqueId}\n\nYour Cultural Seva request has been sent to the administration for review.\n\nYour program will be booked only after Admin approval.`
    );

    setCulturalForm({
      name: "",
      contact: "",
      category: "",
      otherCategory: "",
    });

    setBookingType("solo");
    setGroupCount(2);
    setSelectedDateId("");
  } catch (error) {
    console.error(
      "Cultural booking submission failed:",
      error
    );

    alert(
      "Unable to submit your request. Please try again."
    );
  } finally {
    setIsSubmittingCultural(false);
  }
};
  // --- 2. State & Effects ---
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [activeSlot, setActiveSlot] = useState(null);
  const [formData, setFormData] = useState({ name: "", contact: "" });
  const [isScrolled, setIsScrolled] = useState(false);
  const [statusSearch, setStatusSearch] = useState("");
  const [statusResults, setStatusResults] = useState([]);
  const [isCheckingStatus, setIsCheckingStatus] = useState(false);
  const [statusSearched, setStatusSearched] = useState(false);
  const [statusError, setStatusError] = useState("");
  

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
  if (!isScrolled) setIsMenuOpen(false);
}, [isScrolled]);

  // --- 3. Handlers ---
  const openModal = (slot) => {
    setActiveSlot(slot);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setActiveSlot(null);
    setFormData({ name: "", contact: "" });
  };

  // --- Find the currently ongoing event for the highlight card ---
  const ongoingEvent = dailySchedule.find(item => item.status === 'ongoing') 
    || dailySchedule.find(item => item.status === 'future') 
    || dailySchedule[dailySchedule.length - 1];

  const formatCulturalTimestamp = (timestamp) => {
  if (!timestamp?.toDate) return "Not available";

  return timestamp.toDate().toLocaleString("en-IN", {
    day: "numeric",
    month: "long",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });
};

const formatCulturalTime = (time) => {
  if (!time) return "Not allocated";

  const [hours, minutes] = time.split(":").map(Number);

  const date = new Date();
  date.setHours(hours, minutes, 0, 0);

  return date.toLocaleTimeString("en-IN", {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });
};

const getDurationLabel = (duration) => {
  const value = Number(duration);

  if (value === 60) return "1 Hour";
  if (value === 45) return "45 Minutes";
  if (value === 30) return "30 Minutes";

  return duration ? `${duration} Minutes` : "Not allocated";
};

const handleCheckCulturalStatus = async (e) => {
  e.preventDefault();

  const searchValue = statusSearch.trim();

  setStatusResults([]);
  setStatusError("");
  setStatusSearched(false);

  if (!searchValue) {
    setStatusError(
      "Please enter your Cultural Seva Booking ID or mobile number."
    );
    return;
  }
  try {
    setIsCheckingStatus(true);
    const requestsRef = collection(db, "culturalRequests");
    let statusQuery;
    if (/^KMCP\d+$/i.test(searchValue)) {
      statusQuery = query(
        requestsRef,
        where("bookingId", "==", searchValue.toUpperCase())
      );
    } else if (/^[6-9]\d{9}$/.test(searchValue)) {
      statusQuery = query(
        requestsRef,
        where("contact", "==", searchValue)
      );
    } else {
      setStatusError(
        "Enter a valid Booking ID or 10-digit mobile number."
      );

      return;
    }

    const snapshot = await getDocs(statusQuery);

    const results = snapshot.docs.map((requestDoc) => ({
      id: requestDoc.id,
      ...requestDoc.data(),
    }));

    results.sort((a, b) => {
      const firstTime =
        a.createdAt?.toMillis?.() || 0;

      const secondTime =
        b.createdAt?.toMillis?.() || 0;

      return secondTime - firstTime;
    });

    setStatusResults(results);
    setStatusSearched(true);

  } catch (error) {
    console.error(
      "Failed to check Cultural Seva status:",
      error
    );

    setStatusError(
      "Unable to check the booking status. Please try again."
    );
  } finally {
    setIsCheckingStatus(false);
  }
};
  return (
    <div className="min-h-screen bg-[#FCF8F2] font-sans text-gray-900 selection:bg-[#722013] selection:text-[#FCF8F2] overflow-x-hidden">
      {/* Decorative Background Elements (Temple Geometry) */}
      <div className="fixed inset-0 pointer-events-none z-0 opacity-[0.03] bg-[url('https://www.transparenttextures.com/patterns/arabesque.png')] mix-blend-multiply"></div>
      <div className="fixed top-[-20%] right-[-10%] w-[800px] h-[800px] rounded-full bg-gradient-to-br from-[#f8e5cc] to-transparent opacity-40 blur-3xl -z-10"></div>
      {/* --- PREMIUM FLOATING HEADER --- */}
      <Header/>
      {/* --- CINEMATIC HERO SECTION --- */}
      <Element name="top">
        <Hero />
      </Element>
      {/* --- QUICK ACTIONS (Premium Feature Cards) --- */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 mt-12 mb-20 lg:mb-10">
        {/* Unified Floating Dock Container */}
        <div className="bg-white/95 backdrop-blur-xl border border-[#E8DCC4] shadow-[0_15px_40px_-15px_rgba(42,11,6,0.1)] rounded-2xl md:rounded-[2rem] p-2 sm:p-3 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-1 sm:gap-2">
          {[
            {
              ...t.quickActions[0],
              icon: Sparkles,
              link: "/book-seva",
            },
            {
              ...t.quickActions[1],
              icon: BookHeart,
              link: "/virtual-pada-puja",
            },
            {
              ...t.quickActions[2],
              icon: CalendarDays,
              href: "#cultural",
            },
            {
              ...t.quickActions[3],
              icon: Clock,
              href: "#schedule",
            },
          ].map((item, idx) => {
            
            const Interior = () => (
              <div className="group flex items-center gap-4 p-3 md:px-5 md:py-4 rounded-xl md:rounded-2xl hover:bg-[#FAF6F0] transition-colors duration-300 w-full cursor-pointer">
                {/* Compact Icon Badge */}
                <div className="w-10 h-10 shrink-0 rounded-full bg-[#722013]/5 border border-[#722013]/10 flex items-center justify-center group-hover:bg-[#722013] group-hover:border-[#722013] transition-colors duration-300">
                  <item.icon className="w-4 h-4 text-[#722013] group-hover:text-white transition-colors duration-300" />
                </div>

                {/* Text Content */}
                <div className="flex-1 min-w-0">
                  <h3 className="font-serif font-bold text-[#2a0b06] text-sm md:text-base leading-tight truncate group-hover:text-[#722013] transition-colors">
                    {item.title}
                  </h3>
                  <p className="text-[10px] sm:text-xs text-[#5a5046] mt-0.5 truncate">
                    {item.desc}
                  </p>
                </div>

                {/* Action Arrow */}
                <div className="shrink-0 text-gray-300 opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 group-hover:text-[#D4AF37] transition-all duration-300">
                  <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M9 5l7 7-7 7" />
                  </svg>
                </div>
              </div>
            );

            return (
              <motion.div 
                key={idx}
                initial={{ opacity: 0, y: 15 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: idx * 0.05 }}
              >
                {item.link ? (
                  <Link to={item.link} className="block w-full">
                    <Interior />
                  </Link>
                ) : (
                  <a href={item.href} className="block w-full">
                    <Interior />
                  </a>
                )}
              </motion.div>
            );
          })}
        </div>
      </section>

      <main className="max-w-7xl mx-auto px-6 space-y-10 mb-32">
        {/* --- 2. DAILY SCHEDULE (Calendar & Live Highlight) --- */}
        <LiveBroadcast/>
         <Element name="schedule">
          <Schedule />
        </Element>
      <InvitationSection />
        <Element name="cultural">
          <CBookingUser
            culturalDates={culturalDates}
            getRemainingSlots={getRemainingSlots}

            selectedDateId={selectedDateId}
            setSelectedDateId={setSelectedDateId}

            selectedDateData={selectedDateData}
            selectedDateRemainingSlots={selectedDateRemainingSlots}

            culturalForm={culturalForm}
            setCulturalForm={setCulturalForm}

            bookingType={bookingType}
            setBookingType={setBookingType}

            groupCount={groupCount}
            setGroupCount={setGroupCount}

            isSubmittingCultural={isSubmittingCultural}

            handleCulturalSubmit={handleCulturalSubmit}
          />
        </Element>
        <CulturalStatusTracker
          statusSearch={statusSearch}
          setStatusSearch={setStatusSearch}

          statusResults={statusResults}
          setStatusResults={setStatusResults}

          isCheckingStatus={isCheckingStatus}

          statusSearched={statusSearched}
          setStatusSearched={setStatusSearched}

          statusError={statusError}
          setStatusError={setStatusError}

          handleCheckCulturalStatus={handleCheckCulturalStatus}

          formatCulturalTime={formatCulturalTime}
          formatCulturalTimestamp={formatCulturalTimestamp}
          getDurationLabel={getDurationLabel}
        />
        <Bio/>
        {/* <Element name="gallery">
          <Gallery/>
        </Element> */}
        {/* <MantrakshataRequest/> */}
        <Element name="blogs">
          <BlogSection />
        </Element>
      </main>
 
     <ReviewSection/>
      
      {/* --- PREMIUM FOOTER --- */}
      <Element name="contact">
        <Footer />
      </Element>
 
      {/* --- CULTURAL BOOKING MODAL (Glassmorphism) --- */}
      <AnimatePresence>
        {isModalOpen && activeSlot && (
          <motion.div  
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 z-[100] flex items-center justify-center bg-black/40 backdrop-blur-md px-4"
          >
            <motion.div 
              initial={{ scale: 0.95, opacity: 0, y: 20 }}
              animate={{ scale: 1, opacity: 1, y: 0 }}
              exit={{ scale: 0.95, opacity: 0, y: 20 }}
              className="bg-[#FCF8F2] rounded-[2rem] shadow-2xl w-full max-w-md overflow-hidden relative border border-white"
            >
              <div className="bg-white px-8 py-6 border-b border-[#E8DCC4] flex justify-between items-center">
                <div>
                  <h3 className="font-serif font-bold text-2xl text-[#2a0b06]">Request Slot</h3>
                  <p className="text-xs text-gray-500 font-medium mt-1">Admin will verify and confirm via SMS.</p>
                </div>
                <button onClick={closeModal} className="text-gray-400 hover:text-gray-900 hover:bg-gray-100 rounded-full p-2 transition-colors">
                  <X className="w-5 h-5" />
                </button>
              </div>
              
              <form onSubmit={handleCulturalSubmit} className="p-8 space-y-6">
                <div className="bg-[#FAF6F0] p-5 rounded-2xl border border-[#E8DCC4] flex justify-between items-center shadow-inner">
                  <div>
                    <div className="font-bold text-[#722013] text-lg font-serif">{activeSlot.title}</div>
                    <div className="text-gray-500 text-xs mt-1 font-medium">{activeSlot.date}</div>
                  </div>
                  <div className="text-right">
                    <div className="text-[10px] text-gray-400 font-bold uppercase tracking-widest mb-1">Time Slot</div>
                    <div className="font-bold text-gray-800 text-sm">{activeSlot.time.split('-')[0]}</div>
                  </div>
                </div>

                <div className="space-y-4">
                  <div>
                    <label className="block text-[10px] font-bold text-gray-500 uppercase tracking-widest mb-2 ml-1">Full Name</label>
                    <input 
                      type="text" 
                      required
                      value={formData.name}
                      onChange={(e) => setFormData({...formData, name: e.target.value})}
                      className="w-full px-5 py-3.5 rounded-xl border border-gray-200 focus:ring-2 focus:ring-[#D4AF37] focus:border-[#D4AF37] outline-none text-sm transition bg-white shadow-sm font-medium"
                      placeholder="Enter your full name"
                    />
                  </div>

                  <div>
                    <label className="block text-[10px] font-bold text-gray-500 uppercase tracking-widest mb-2 ml-1">Contact Number</label>
                    <input 
                      type="tel" 
                      required
                      value={formData.contact}
                      onChange={(e) => setFormData({...formData, contact: e.target.value})}
                      className="w-full px-5 py-3.5 rounded-xl border border-gray-200 focus:ring-2 focus:ring-[#D4AF37] focus:border-[#D4AF37] outline-none text-sm transition bg-white shadow-sm font-medium"
                      placeholder="+91 XXXXX XXXXX"
                    />
                  </div>
                </div>

                <div className="pt-4">
                  <button 
                    type="submit"
                    className="w-full bg-[#722013] text-white py-4 rounded-xl font-bold text-sm hover:bg-[#5a190f] transition-all duration-300 shadow-lg shadow-[#722013]/20 flex justify-center items-center gap-2"
                  >
                    Submit Request <ArrowRight className="w-4 h-4" />
                  </button>
                </div>
              </form>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

const homeText = {
  en: {
    quickActions: [
      {
        title: "Book Pada Pooja",
        desc: "Reserve sacred rituals",
      },
      {
        title: "Virtual Pooja",
        desc: "Submit details online",
      },
      {
        title: "Cultural Events",
        desc: "View & book activities",
      },
      {
        title: "Daily Schedule",
        desc: "Timings for all rituals",
      },
    ],
  },

  kn: {
    quickActions: [
      {
        title: "ಪಾದ ಪೂಜೆ ಬುಕ್ಕಿಂಗ್",
        desc: "ಪವಿತ್ರ ಸೇವೆಯನ್ನು ಕಾಯ್ದಿರಿಸಿ",
      },
      {
        title: "ವರ್ಚುವಲ್ ಪೂಜೆ",
        desc: "ಆನ್‌ಲೈನ್‌ನಲ್ಲಿ ವಿವರಗಳನ್ನು ಸಲ್ಲಿಸಿ",
      },
      {
        title: "ಕಾರ್ಯಕ್ರಮಗಳು",
        desc: "ಕಾರ್ಯಕ್ರಮಗಳನ್ನು ವೀಕ್ಷಿಸಿ ಮತ್ತು ಬುಕ್ ಮಾಡಿ",
      },
      {
        title: "ವೇಳಾಪಟ್ಟಿ",
        desc: "ಎಲ್ಲಾ ಸೇವೆಗಳ ಸಮಯಗಳು",
      },
    ],
  },
};
// Helper component for Quick Action Cards
const CardContent = ({ item }) => (
  <>
    <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-bl from-[#FAF6F0] to-transparent rounded-bl-full -z-10 group-hover:scale-110 transition-transform duration-500"></div>
    <div className="mb-6 bg-[#FAF6F0] p-4 rounded-2xl text-[#722013] inline-block group-hover:bg-[#722013] group-hover:text-[#D4AF37] transition-colors duration-500 shadow-inner">
      <item.icon className="w-8 h-8" />
    </div>
    <h3 className="text-xl font-bold text-gray-900 mb-2 font-serif group-hover:text-[#722013] transition-colors">{item.title}</h3>
    <p className="text-gray-500 text-sm leading-relaxed font-medium mb-4">{item.desc}</p>
    <div className="flex items-center gap-2 text-[#722013] text-xs font-bold uppercase tracking-wider opacity-0 -translate-x-4 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300">
      Explore <ArrowRight className="w-3 h-3" />
    </div>
  </>
);

export default Home;  